"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORBIDDEN_HOSTNAMES = exports.bmcAddressValidationMessages = exports.locationValidationMessages = exports.hostnameValidationMessages = exports.BMCValidationMessages = exports.nameValidationMessages = exports.acmClusterNameValidationMessages = exports.uniqueOcmClusterNameValidationMessages = exports.ocmClusterNameValidationMessages = exports.clusterNameValidationMessages = exports.CLUSTER_NAME_MAX_LENGTH = void 0;
exports.CLUSTER_NAME_MAX_LENGTH = 54;
const clusterNameValidationMessages = (t) => ({
    INVALID_LENGTH_OCM: t('ai:1-{{count}} characters', { count: exports.CLUSTER_NAME_MAX_LENGTH }),
    INVALID_LENGTH_ACM: t('ai:2-{{count}} characters', { count: exports.CLUSTER_NAME_MAX_LENGTH }),
    INVALID_VALUE: t('ai:Use lowercase alphanumeric characters or hyphen (-)'),
    INVALID_START_END: t('ai:Start and end with a lowercase letter or a number.'),
    NOT_UNIQUE: t('ai:Must be unique'),
});
exports.clusterNameValidationMessages = clusterNameValidationMessages;
const ocmClusterNameValidationMessages = (t) => ({
    INVALID_LENGTH: (0, exports.clusterNameValidationMessages)(t).INVALID_LENGTH_OCM,
    INVALID_VALUE: (0, exports.clusterNameValidationMessages)(t).INVALID_VALUE,
    INVALID_START_END: (0, exports.clusterNameValidationMessages)(t).INVALID_START_END,
});
exports.ocmClusterNameValidationMessages = ocmClusterNameValidationMessages;
const uniqueOcmClusterNameValidationMessages = (t) => ({
    INVALID_LENGTH: (0, exports.clusterNameValidationMessages)(t).INVALID_LENGTH_OCM,
    INVALID_VALUE: (0, exports.clusterNameValidationMessages)(t).INVALID_VALUE,
    INVALID_START_END: (0, exports.clusterNameValidationMessages)(t).INVALID_START_END,
    NOT_UNIQUE: (0, exports.clusterNameValidationMessages)(t).NOT_UNIQUE,
});
exports.uniqueOcmClusterNameValidationMessages = uniqueOcmClusterNameValidationMessages;
const acmClusterNameValidationMessages = (t) => ({
    INVALID_LENGTH: (0, exports.clusterNameValidationMessages)(t).INVALID_LENGTH_ACM,
    INVALID_VALUE: (0, exports.clusterNameValidationMessages)(t).INVALID_VALUE,
    INVALID_START_END: (0, exports.clusterNameValidationMessages)(t).INVALID_START_END,
    NOT_UNIQUE: (0, exports.clusterNameValidationMessages)(t).NOT_UNIQUE,
});
exports.acmClusterNameValidationMessages = acmClusterNameValidationMessages;
const nameValidationMessages = (t) => ({
    INVALID_LENGTH: t('ai:1-253 characters'),
    NOT_UNIQUE: t('ai:Must be unique'),
    INVALID_VALUE: t('ai:Use lowercase alphanumeric characters, dot (.) or hyphen (-)'),
    INVALID_START_END: t('ai:Must start and end with an lowercase alphanumeric character'),
    INVALID_FORMAT: t('ai:Number of characters between dots (.) must be 1-63'),
});
exports.nameValidationMessages = nameValidationMessages;
const BMCValidationMessages = (t) => (Object.assign(Object.assign({}, (0, exports.nameValidationMessages)(t)), { LOCALHOST_ERR: t('ai:Do not use forbidden words, for example: "localhost".') }));
exports.BMCValidationMessages = BMCValidationMessages;
const hostnameValidationMessages = (t) => ({
    INVALID_LENGTH: t('ai:1-63 characters'),
    NOT_UNIQUE: t('ai:Must be unique'),
    INVALID_VALUE: t('ai:Use lowercase alphanumeric characters, dot (.) or hyphen (-)'),
    INVALID_START_END: t('ai:Must start and end with an lowercase alphanumeric character'),
    LOCALHOST_ERR: t('ai:Do not use forbidden words, for example: "localhost".'),
});
exports.hostnameValidationMessages = hostnameValidationMessages;
const locationValidationMessages = (t) => ({
    INVALID_LENGTH: t('ai:1-63 characters'),
    INVALID_VALUE: t('ai:Use alphanumeric characters, dot (.), underscore (_) or hyphen (-)'),
    INVALID_START_END: t('ai:Must start and end with an alphanumeric character'),
});
exports.locationValidationMessages = locationValidationMessages;
const bmcAddressValidationMessages = (t) => ({
    INVALID_VALUE: t('ai:The Value is not valid BMC address, supported protocols are redfish-virtualmedia or idrac-virtualmedia.'),
});
exports.bmcAddressValidationMessages = bmcAddressValidationMessages;
exports.FORBIDDEN_HOSTNAMES = [
    'localhost',
    'localhost.localdomain',
    'localhost4',
    'localhost4.localdomain4',
    'localhost6',
    'localhost6.localdomain6',
];
//# sourceMappingURL=constants.js.map